import { mods } from '@approvalmax/theme';
import { Field, font, RadioGroupEditor } from '@approvalmax/ui';
import { StyledMods } from '@styled-kit/mods';
import { LineItemsTable } from 'pages/requestForm/components/lineItemsSection/LineItemsTable/LineItemsTable';
import styled, { css } from 'styled-components';

export const SectionHeader = styled.div<StyledMods<{ noMarginTop?: boolean }>>`
    text-transform: uppercase;
    margin-top: 30px;
    margin-bottom: 18px;

    ${font(18, '#333')}

    &:first-child {
        margin-top: 0;
    }

    ${mods('noMarginTop', true)`
        margin-top: 0;    
    `}
`;

export const FieldsWrapper = styled.div<StyledMods<{ hasGap: boolean; marginBottom?: number }>>`
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 10px;

    ${mods('hasGap', true)`
        gap: 10px;
    `}

    ${mods('marginBottom')(
        (value) => css`
            margin-bottom: ${value}px;
        `
    )}
`;

export const StyledField = styled(Field)`
    width: calc(50% - 5px);
`;

export const WorkflowStyledField = styled(Field)`
    width: 267px;
    min-width: 267px;
    margin-bottom: 8px;
    margin-right: 30px;
`;

export const WorkflowCurrenciesField = styled(Field)`
    min-width: 267px;
    margin-bottom: 8px;

    & input {
        min-width: 73px;
    }
`;

export const StyledLineItemsTable = styled(LineItemsTable)`
    position: relative;
    left: -60px;
    width: calc(100% + 120px);
    margin-top: 15px;

    & .reqf-line-items-table-header {
        padding: 0 60px;
    }

    & .reqf-line-items-table-row__row-before {
        width: 60px;
    }

    & .reqf-line-items-table-row__row-after {
        width: 60px;
    }

    & .reqf-line-items-table__add-line-button {
        margin: 0 60px;
    }
`;

export const StyledAddressLineItemsTable = styled(LineItemsTable)`
    position: relative;
    left: -60px;
    width: calc(100% + 120px);
    margin-top: 15px;
    overflow: auto;

    & .reqf-line-items-table-header {
        padding: 0 60px;
    }

    & .reqf-line-items-table-row__row-before {
        width: 60px;
    }

    & .reqf-line-items-table-row__row-after {
        width: 60px;
    }

    & .reqf-line-items-table__add-line-button {
        margin: 0 60px 15px 60px;
        border: none;
    }

    & .reqf-line-items-table-row__row-body {
        overflow: initial;
    }
`;

export const CheckboxCell = styled.div`
    display: flex;
    align-items: center;
`;

export const InlineRadioEditor = styled(RadioGroupEditor)`
    display: flex;
    align-items: center;
    gap: 15px;
`;

export const RadioGroupEditorLabel = styled.div<StyledMods<{ hasMarginRight: boolean }>>`
    ${font(12, '#5e5c5c', 'bold')}

    ${mods('hasMarginRight', true)`
        margin-right: 10px;
    `}
`;
